import React from 'react';
import PropTypes from 'prop-types';

import { SubHeader } from 'cstar-react-primitives';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useFormatMessage } from '../../intl/intlHooks';
import { orderSummaryTotalsMessages } from './orderSummaryMessages';

export const sumTotal = (subTotal, shipping = 0, promoTotal =0, totalFees = 0) => {
    return parseFloat(subTotal) + parseFloat(shipping) + parseFloat(totalFees) - parseFloat(promoTotal);
};

export const OrderSummaryTotals = ({ subTotal, quantity, shipping, totalFees, promoTotal, feeQuantity }) => {
    const formatMessage = useFormatMessage();
    return (
        <div className="order-summary-totals">
            <SubHeader heading={formatMessage(orderSummaryTotalsMessages.orderSummaryLabel)} />
            <div className="order-summary-totals-line">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalsMessages.cardSubtotal} values={{ quantity }} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={subTotal} format="currency" />
                </div>
            </div>
            {shipping > 0 && (
                <div className="order-summary-totals-line">
                    <div className="order-summary-totals-label">
                        <FormattedMessage {...orderSummaryTotalsMessages.shipping} />
                    </div>
                    <div className="order-summary-totals-value">
                        <FormattedNumber value={shipping} format="currency" />
                    </div>
                </div>
            )}
            {totalFees > 0 && (
                <div className="order-summary-totals-line">
                    <div className="order-summary-totals-label">
                        <FormattedMessage {...orderSummaryTotalsMessages.fees} values={{ feeQuantity }} />
                    </div>
                    <div className="order-summary-totals-value">
                        <FormattedNumber value={totalFees} format="currency" />
                    </div>
                </div>
            )}
            {promoTotal > 0 && (
                <div className="order-summary-totals-line">
                    <div className="order-summary-totals-label">
                        <FormattedMessage {...orderSummaryTotalsMessages.discounts} />
                    </div>
                    <div className="order-summary-totals-value">
                        <FormattedNumber value={-promoTotal} format="currency" />
                    </div>
                </div>
            )}
            <div className="order-summary-totals-line order-summary-totals-total">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalsMessages.total} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={sumTotal(subTotal, shipping, promoTotal, totalFees)} format="currency" />
                </div>
            </div>
        </div>
    );
};

OrderSummaryTotals.defaultProps = {
    promoTotal: '0.00',
    totalFees: '0.00',
    feeQuantity: '0'
};

OrderSummaryTotals.propTypes = {
    subTotal: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    shipping: PropTypes.number.isRequired,
    promoTotal: PropTypes.string,
    totalFees: PropTypes.string,
    feeQuantity: PropTypes.string
};
